import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Prompt, useHistory } from "react-router-dom";

import { Alert } from "../../feedback/alert/index.jsx";

export const RoutePrompt = (props) => {
  const { showConfirm } = Alert;
  const {
    title,
    content,
    okText,
    cancelText,
    isShowModal,
    onOK = () => {},
    onCancel = () => {}
  } = props;
  const [confirmedNotification, setConfirmedNotification] = useState(false);
  const lastLocation = useRef(null);
  const history = useHistory();

  const handleBlockedNavigation = (nextLocation) => {
    if (isShowModal() && !confirmedNotification) {
      lastLocation?.current !== nextLocation.pathname &&
        showConfirm({
          title: title,
          content: content,
          okText: okText,
          cancelText: cancelText,
          onCancel: () => {
            lastLocation.current = null;
            onCancel();
          },
          onOK: handleConfirmNavigationClick
        });
      lastLocation.current = nextLocation.pathname;
      return false;
    }
    return true;
  };

  const handleConfirmNavigationClick = () => {
    setConfirmedNotification(true);
    onOK();
  };

  useEffect(
    function getConfirmedNotification() {
      if (confirmedNotification && lastLocation.current) {
        history.push(lastLocation.current);
        lastLocation.current = null;
        setConfirmedNotification(false);
      }
    },
    [confirmedNotification, history]
  );

  return <Prompt message={handleBlockedNavigation} />;
};

RoutePrompt.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string.isRequired,
  okText: PropTypes.string,
  cancelText: PropTypes.string,
  isShowModal: PropTypes.func.isRequired,
  onOK: PropTypes.func,
  onCancel: PropTypes.func
};
